import { render, staticRenderFns } from "./ProtocolloRubricaEdit.vue?vue&type=template&id=455a0723"
import script from "./ProtocolloRubricaEdit.vue?vue&type=script&lang=js"
export * from "./ProtocolloRubricaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports